import { render } from "./AddNewItem.vue?vue&type=template&id=25413a9b&scoped=true"
import script from "./AddNewItem.vue?vue&type=script&lang=js"
export * from "./AddNewItem.vue?vue&type=script&lang=js"

import "./AddNewItem.vue?vue&type=style&index=0&id=25413a9b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25413a9b"]])

export default __exports__